import React from 'react';
import Header from '../../Shared/Header';
import Sidebar from '../Shared/Sidebar';
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import line from '../../../images/line.png';
import { loadUser, loadInvestors } from '../../../actions/auth';
import GraphView from '../../Shared/GraphAction/GraphView';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ButtonScrollUp from '../../Shared/ButtonScrollUp';

function Kpis(props) {
  const { t, i18n } = useTranslation();
  const current_language = i18n.language;
  let { user, investors } = props;
  let { loadUser, loadInvestors } = props;

  if (!user) {
    loadUser();
    return <Spinner animation='grow' variant='info' className='loader' />;
  } else if (!investors) {
    loadInvestors();
    return <Spinner animation='grow' variant='info' className='loader' />;
  } else if (user.status === 'Pending') {
    let termsOfAgreementRoute = `/terms-of-agreement/${current_language}`;
    return <Navigate to={termsOfAgreementRoute} />;
  } else {
    let investor = investors[0];
    return (
      <div className='container-scroller'>
        <Header />
        <div className='container-fluid page-body-wrapper'>
          <Sidebar investor={investor} />
          <div className='main-panel'>
            <div className='content-wrapper'>
              <div className='row padding-top'>
                <div className='d-sm-flex align-items-center justify-content-between'>
                  <span>
                    <img src={line} className='heading-line' />
                    <span className='header-2 padding-left'>{t('misc.dashboard')}</span>
                  </span>
                </div>
              </div>
              <div className='padding-left'>
                <GraphView businessEntity={investor} />
              </div>
            </div>
          </div>
          <ButtonScrollUp />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  investors: state.auth.investors,
});

export default connect(mapStateToProps, { loadUser, loadInvestors })(Kpis);
